/* eslint-disable @nice-cxone/ccf/required-tsdoc */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const GA_LOGIN_FEATURE_KEY = 'gaLoginSlice';

export interface gaLoginState {
  isAuthenticated: boolean;
}

export const gaInitialLoginState: gaLoginState = {
  isAuthenticated: false,
};

export const gaLoginSlice = createSlice({
  name: GA_LOGIN_FEATURE_KEY,
  initialState: gaInitialLoginState,
  reducers: {
    login(state, action: PayloadAction<any>) {
      state.isAuthenticated = action.payload;
    },
  },
});

export const gaLoginActions = gaLoginSlice.actions;
export const gaLoginReducer = gaLoginSlice.reducer;
